<div class="skeleton-card">
  <div class="skeleton-title">{{title}}</div>

  <div class="skeleton-content">
    <span class="skeleton-line skeleton-line-medium"></span>
    <span class="skeleton-line"></span>
    <span class="skeleton-line"></span>
    <span class="skeleton-line skeleton-line-short"></span>
  </div>
  <!--div class="skeleton-message" [innerHTML]="message"></div-->
  @if (log.length > 0) {
  <div class="log" #progressLogWrapper>
    @for (log of log; track log) {
      <div class="log-message" [innerHTML]="log"></div>
    }
  </div>
  }
</div>